import vData from "./v-data.vue";

export default Vue => {
  Vue.component("v-data", vData);
};
